/**
 * Role-Based Route Component
 * Restricts access to routes based on user role
 */
import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { ShieldAlert } from 'lucide-react';

const RoleBasedRoute = ({ children, allowedRoles = [], redirectTo = null }) => {
  const { userRole } = useApp();

  // If no role set yet, don't render (ProtectedRoute will handle auth)
  if (!userRole) {
    return null;
  }

  // Director, Finance, and Viewer (read-only auditor) have view access to everything
  if (userRole === 'director' || userRole === 'finance' || userRole === 'viewer') {
    return children;
  }

  // Check if user's role is in allowed roles
  if (allowedRoles.includes(userRole)) {
    return children;
  }

  // If redirectTo is specified, redirect there
  if (redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  // Show access denied page
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center p-8 bg-white rounded-2xl shadow-lg max-w-md">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
          <ShieldAlert className="w-8 h-8 text-red-600" />
        </div>
        <h2 className="text-xl font-bold text-gray-800 mb-2">Akses Ditolak</h2>
        <p className="text-gray-500 mb-4">
          Maaf, anda tidak mempunyai kebenaran untuk mengakses halaman ini.
        </p>
        <p className="text-sm text-gray-400">
          Role anda: <span className="font-semibold text-blue-600 uppercase">{userRole}</span>
        </p>
      </div>
    </div>
  );
};

export default RoleBasedRoute;
